import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import dompurify from "isomorphic-dompurify";
import { __ } from "@jti/fe-common";
import { MessageBox, MessageBoxVariant } from "@jti/ui";
import styles from "./DiscountDisclaimer.module.scss";
const { sanitize } = dompurify;
export const DiscountDisclaimer = ({ disclaimerMessage, warningMessage }) => (_jsx(MessageBox, { className: styles.container, title: disclaimerMessage && __("cart.checkout.discount_disclaimer_title"), variant: MessageBoxVariant.warning, isVisible: !!disclaimerMessage || !!warningMessage, children: _jsxs(_Fragment, { children: [!!disclaimerMessage && (_jsx("div", { className: styles.item, dangerouslySetInnerHTML: {
                    __html: sanitize(disclaimerMessage),
                } })), !!warningMessage && (_jsx("div", { className: styles.item, dangerouslySetInnerHTML: {
                    __html: sanitize(warningMessage),
                } }))] }) }));
//# sourceMappingURL=DiscountDisclaimer.js.map